import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { H2, link } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { Content } from '../../../theme/layout';
import { SwipableList as SwipableListComponent } from './swipableList';
import { themeColor } from '../../../theme/getters';
import { animatedPlaceholder } from '../../../theme/mixins';

export const Container = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Title = styled(H2)`
  text-align: center;
  font-size: 32px;
  line-height: 42px;

  ${media.tablet`
    font-size: 45px;
    line-height: 53px;
  `};
`;

export const SwipableList = styled(SwipableListComponent)`
  padding-top: 48px;
`;

const linkMargin = css`
  margin-top: 8px;
  ${media.tablet`
    margin-top: 24px;
  `};
`;

export const Link = styled(RouterLink)`
  ${link};
  color: ${themeColor('gray')};
  ${linkMargin}
`;

export const TitlePlaceholder = styled.div`
  ${animatedPlaceholder};
  width: 200px;
  height: 40px;

  ${media.tablet`
    width: 312px;
    height: 54px;
  `}
`;

export const SubTitlePlaceholder = styled.div`
  ${animatedPlaceholder};
  ${linkMargin};
  width: 150px;
  height: 20px;

  ${media.tablet`
    width: 162px;
    height: 34px;
  `}
`;
